/**
 * Guía: Informes de Soporte.
 *
 * Contenido derivado del capítulo **41** del manual: §0 (comparten
 * controlador con los financieros y el arreglo fue idéntico) y del flujo
 * F34 §6, que separa las dos familias de informe.
 *
 * Como los financieros, el documento sale de la plataforma: la revisión va
 * antes de generarlo.
 */

import type { TourFlow } from '../types';

const INFORMES_PATH = '/reports';

export const c41InformesDeSoporte: TourFlow = {
  id: 'admin.reports',
  chapter: '41',
  title: 'Informes de Soporte',
  summary:
    'Documentos de la operación de soporte: qué responde cada uno y por qué el rango se revisa antes.',
  href: INFORMES_PATH,
  requiresCountry: true,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Informes de la operación, no de dinero',
      body:
        'Tickets, tiempos de respuesta, carga por agente. Comparten mecánica con los ' +
        'informes financieros —rango explícito, ámbito por país, documento que se descarga— ' +
        'pero responden otras preguntas y los ve gente distinta.',
      route: INFORMES_PATH,
    },
    {
      id: 'pick-the-right-one',
      title: 'Cada informe responde una pregunta',
      body:
        'No son variantes del mismo documento. Un informe de soporte no sirve para responder ' +
        'una pregunta de facturación, ni al revés.',
      target: 'admin.reports.cards',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'range-first',
      title: 'El rango se revisa antes de generar',
      body:
        'El periodo se recorta en la zona horaria del país, y el documento sale con esa ' +
        'información dentro. Una vez enviado no se corrige: se emite otro.',
    },
  ],
};
